import React, { useEffect, useState } from 'react';
import Axios from 'axios';
import { connect } from 'react-redux';
import { API_URL } from '../../config';
import axios from 'axios';
import Grid from '@material-ui/core/Grid';
import './commons.css'
import { cacheSalesMasterData, loadSalesMasterData } from "../../lib/offlineSales";
let InstitutionProfile = ({ authInfo }) => {
    let [institution, institutionSet] = useState(null);
    useEffect(() => {
        let isMounted = true;
        const loadProfile = async () => {
            try {
                const cachedInstitution = await loadSalesMasterData("institution-profile", null);
                if (cachedInstitution && isMounted) {
                    institutionSet(cachedInstitution);
                }

                if (navigator.onLine === false || !authInfo?.token) {
                    return;
                }

                await getProfile();
            } catch (_error) {
                if (isMounted) {
                    institutionSet((prev) => prev || null);
                }
            }
        };

        loadProfile();
        return () => {
            isMounted = false;
        };
    }, [authInfo?.token])

    let getProfile = async () => {
        try {
            const res = await axios.get(`${API_URL}/api/get-institution`, {
                headers: { 'auth-token': authInfo.token },
                showNetworkLoader: false,
            });
            const nextValue = res?.data || null;
            institutionSet(nextValue);
            await cacheSalesMasterData("institution-profile", nextValue);
        } catch (_error) {
            try {
                const cachedInstitution = await loadSalesMasterData("institution-profile", null);
                institutionSet(cachedInstitution);
            } catch (_cacheError) {
                institutionSet(null);
            }
        }
    }

    return (
        <div className="print-source">
            <html lang="en">
                <head>
                    <meta http-equiv="X-UA-Compatible" content="IE=edge,chrome=1" />
                    <meta charset="utf-8" />
                    <meta name="description" content="Static &amp; Dynamic Tables" />
                    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0" />
                    <title>Profile</title>
                </head>
                <body>

                    <div style={{ width: '100%' }}>
                        <div style={{ width: '10%', float: 'left', marginLeft: '3%' }}>
                            <img
                                alt={institution != null ? institution.pro_name : ''}
                                src={
                                    institution != null && institution.pro_logo
                                        ? `${API_URL}/${institution.pro_logo}`
                                        : `${process.env.PUBLIC_URL}/sbm_logo.svg`
                                }
                                style={{ width: '100px', height: '100px' }}
                            />
                        </div>
                        <div style={{ width: '80%', float: 'right', marginLeft: '5%' }}>
                            <h2 style={{ textAlign: 'center' }}>{institution != null ? institution.pro_name : ''}</h2>
                            <p style={{ textAlign: 'center' }}>{institution != null ? institution.pro_desc : ''}</p>
                        </div>
                    </div>





                </body>
            </html>
        </div>
    )
}

const mapStateToPops = (state) => {
    return {
        authInfo: state.authInfoReducer
    }
}

export default connect(mapStateToPops, {})(InstitutionProfile);
